import { Component, OnInit } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-grafico-ocupacao',
    templateUrl: './grafico-ocupacao.component.html',
    styleUrls: ['./grafico-ocupacao.component.css'],
    standalone: false
})
export class GraficoOcupacaoComponent implements OnInit{
  public chartData!: ChartData<'bar'>;
  public chartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    // Substitua pela URL da sua API
    this.http.get<any[]>('https://sua-api.com/dados').subscribe(data => {
      // Suponha que a API retorna um array de objetos { label: string, value: number }
      const labels = data.map(item => item.label);
      const values = data.map(item => item.value);

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: 'Dados do Gráfico',
            data: values,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          }
        ]
      };
    });
  }
}
